import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalculateService {

  constructor() { }

  GetRoundedAmount(roundingType: number, amount: number): number {
    var roundedAmount = amount;

    if (roundingType === 1) {
      roundedAmount = Math.ceil(amount);
    }
    else if (roundingType === 2) {
      roundedAmount = Math.round(amount * 100) / 100;
    }
    else {
      roundedAmount = Math.ceil(amount);
    }

    return roundedAmount;
  }
}
